import { Col, Row } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledCol = styled(Col)`
  padding-bottom: var(--spacing-02);
`;

interface Props {
  widget1?: React.ReactNode;
  widget2?: React.ReactNode;
  widget3?: React.ReactNode;
  widget4?: React.ReactNode;
}

export const Widgets: FC<Props> = ({ widget1, widget2, widget3, widget4 }) => (
  <Row gutter={[16, 16]}>
    <StyledCol xs={24} md={12} lg={12} xl={5}>
      {widget1}
    </StyledCol>
    <StyledCol xs={24} md={12} lg={12} xl={5}>
      {widget2}
    </StyledCol>
    <StyledCol xs={24} md={12} lg={12} xl={7}>
      {widget3}
    </StyledCol>
    <StyledCol xs={24} md={12} lg={12} xl={7}>
      {widget4}
    </StyledCol>
  </Row>
);
